export default __webpack_public_path__ + "static/media/subway_t.dafbd972.jpeg";